import { useState } from "react";
import { PackageSearch } from "lucide-react";

// Media fallback — a broken/expired image URL should never render the browser's
// default broken-image "?" glyph. Swaps to a clean icon placeholder on load error.
export function SafeImg({ src, alt, className, FallbackIcon = PackageSearch, iconClassName = "h-8 w-8 text-slate-300 dark:text-zinc-600" }) {
  const [broken, setBroken] = useState(false);
  if (!src || broken) {
    return (
      <div className={`flex items-center justify-center bg-slate-100 dark:bg-white/10 ${className || ""}`} data-testid="safe-img-fallback">
        <FallbackIcon className={iconClassName} />
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} loading="lazy" onError={() => setBroken(true)} />;
}
